import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const UserCash = React.lazy(() =>
    import('../UserCash')
);
const userCashRoutesRegistry = [
    {
        path: PAGE_URL.USER_CASH_PAGE,
        element: <UserCash />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default userCashRoutesRegistry;
